import apiSportsSchools from '@/api/sports-schools'
import apiSportsFederations from '@/api/sports-federations'

const state = {
  isLoading: false,
  sportsSchools: [],
  validationErrors: null,
  isSubmitting: false,
}

export const mutationTypes = {
  getSportSchoolsStart: '[sportsSchools] getSportSchoolsStart',
  getSportSchoolsSuccess: '[sportsSchools] getSportSchoolsSuccess',
  getSportSchoolsFailure: '[sportsSchools] getSportSchoolsFailure',

  getAllSchoolsStart: '[sportsSchools all] getAllSchoolsStart',
  getAllSchoolsSuccess: '[sportsSchools all] getAllSchoolsSuccess',
  getAllSchoolsFailure: '[sportsSchools all] getAllSchoolsFailure',

  addSportSchoolsStart: '[sportsSchools] addSportSchoolsStart',
  addSportSchoolsSuccess: '[sportsSchools] addSportSchoolsSuccess',
  addSportSchoolsFailure: '[sportsSchools] addSportSchoolsFailure',
}

export const actionType = {
  getSportSchools: '[sportsSchools] getSportSchools',
  getAllSchools: '[sportsSchools all] getAllSchools',
  addSportSchools: '[sportsSchools] addSportSchools',
}

const mutations = {
  [mutationTypes.getSportSchoolsStart](state) {
    state.isLoading = true
    state.validationErrors = null
  },

  [mutationTypes.getSportSchoolsSuccess](state, payload) {
    state.isLoading = false
    state.sportsSchools = payload.map((school) => ({
      type: 'school',
      ...school,
    }))
  },

  [mutationTypes.getSportSchoolsFailure](state, payload) {
    state.isLoading = false
    state.validationErrors = payload
  },

  [mutationTypes.getAllSchoolsStart](state) {
    state.isLoading = true
    state.validationErrors = null
  },

  [mutationTypes.getAllSchoolsSuccess](state, payload) {
    state.isLoading = false
    state.sportsSchools = payload.list
  },

  [mutationTypes.getAllSchoolsFailure](state, payload) {
    state.isLoading = false
    state.validationErrors = payload
  },

  [mutationTypes.addSportSchoolsStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.addSportSchoolsSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.getSportSchoolsFailure](state) {
    state.isSubmitting = false
  },
}

const actions = {
  [actionType.getSportSchools](context, params) {
    context.commit(mutationTypes.getSportSchoolsStart)
    return new Promise((resolve) => {
      apiSportsSchools
        .getSportSchools(params)
        .then((response) => {
          context.commit(
            mutationTypes.getSportSchoolsSuccess,
            response.data.list
          )
          resolve(response.data.list)
        })
        .catch((error) => {
          context.commit(
            mutationTypes.getSportSchoolsFailure,
            error.response.data.errors
          )
        })
    })
  },

  async [actionType.getAllSchools](context) {
    context.commit(mutationTypes.getAllSchoolsStart)
    try {
      const sportSchool = await apiSportsSchools
        .getSportSchools()
        .then((res) => {
          const data = res.data ? res.data : res
          return data.list.map((item) => ({...item, type: 'school'}))
        })
      const sportFederations = await apiSportsFederations
        .getSportFederations()
        .then((res) => {
          const data = res.data ? res.data : res
          return data.map((item) => ({...item, type: 'federation'}))
        })

      const result = [...sportSchool, ...sportFederations]

      context.commit(mutationTypes.getSportSchoolsSuccess, result)
      return result
    } catch (error) {
      context.commit(mutationTypes.getSportSchoolsFailure, error)
    }
  },

  [actionType.addSportSchools](context, sport) {
    context.commit(mutationTypes.addSportSchoolsStart)
    return new Promise((resolve) => {
      apiSportsSchools
        .addSportSchools(sport)
        .then((response) => {
          context.commit(mutationTypes.addSportSchoolsSuccess, response.data)
          resolve(response.data)
        })
        .catch((result) => {
          context.commit(
            mutationTypes.addSportSchoolsFailure,
            result.response.data.errors
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
